var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVisa = function SvgVisa(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 43,
    height: 30,
    rx: 4,
    fill: "#fff"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 44,
    height: 31,
    rx: 4.5,
    stroke: "#000",
    strokeOpacity: 0.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.739 20.805h2.609l1.633-9.575h-2.61l-1.632 9.575ZM27.244 15.07c-.912-.443-1.471-.74-1.465-1.187 0-.398.473-.824 1.495-.824a4.72 4.72 0 0 1 2.188.477l.354-2.076a6.739 6.739 0 0 0-2.34-.402c-2.578 0-4.395 1.299-4.41 3.16-.015 1.376 1.297 2.144 2.287 2.602 1.016.469 1.358.769 1.353 1.188-.006.642-.811.935-1.562.935-1.158 0-1.742-.18-2.793-.655l-.366 2.144c.61.267 1.737.499 2.908.51 2.744 0 4.525-1.283 4.545-3.271.007-1.09-.688-1.918-2.194-2.601ZM36.507 11.237H34.49c-.625 0-1.092.171-1.367.794l-3.876 8.776h2.74s.449-1.18.55-1.439l3.344.004c.078.335.318 1.435.318 1.435h2.422l-2.114-9.57Zm-3.218 6.173a427.55 427.55 0 0 0 1.386-3.59c.353 1.65.009.048.78 3.59H33.29ZM15.548 11.236l-2.556 6.53-.272-1.327-.915-4.402c-.158-.606-.616-.787-1.183-.808h-4.21l-.033.2c1.024.248 1.94.605 2.742 1.05l2.321 8.317 2.762-.003 4.11-9.558h-2.766Z",
    fill: "#1A1876"
  })));
};
export default SvgVisa;